import React, { Component } from 'react';
export default class PDFExportButton extends Component {
  render() {
    const { pdfRequested, layoutMode, exportFunction } = this.props;
    let exportPDFButtonText;
    if (pdfRequested) {
        if (layoutMode === 'pdfCompleted') {
            exportPDFButtonText = 'Downloading'
        } else {
            exportPDFButtonText = 'Retrieving';
        }
    } else {
        exportPDFButtonText = 'Export as';
    }
    return (
        <button 
            className='btn btn--white ml3 mr2' 
            onClick={exportFunction}
            disabled={pdfRequested && layoutMode !== 'pdfCompleted'}
        >
            {exportPDFButtonText} PDF
        </button>
    );
  }
}
